<template>
  <zt-modal
    class="rounded font-normal"
    :title="$t('message.selfService.title')"
    @close="closeDialog" max-width="600px"
    :active="active"
    :z-index="1001"
  >
    <template>
      <div class="flex px-10 py-12">
        <div class="flex flex-none items-center w-24 h-24 justify-center mr-16">
          <zt-icon
            name="exclamation-circle-outline"
            class="text-zt-warning"
            :style="{ fontSize: '6rem'}"
          />
        </div>
        <div>
          <p class="text-zt-xl mb-4 text-zt-dark-500">
            {{ $t('message.selfService.leaveQuest') }}
          </p>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <div class="zt-modal-footer rounded-b flex justify-end items-center p-4">
        <zt-button
          text
          color="dark-300"
          class="button-cancel mr-4"
          @click="closeDialog"
        >
          {{ $t('message.selfService.linkCancel') }}
        </zt-button>
        <zt-button class="w-25" @click="confirmLeave">
          {{ $t('message.selfService.linkLeave') }}
        </zt-button>
      </div>
    </template>
  </zt-modal>
</template>

<script>
export default {
  name: 'CancelConfigurationDialog',
  inject: [ 'activeDialog', 'resetParams', 'hasHistory' ],
  props: {
    active: {
      type: Boolean,
      default: false
    },
    isLeave: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeDialog() {
      this.activeDialog(false)
    },
    async confirmLeave() {
      if (this.isLeave) {
        this.$emit('confirm-leave', true)
        return
      }
      await this.resetParams()
      this.hasHistory() ? this.$router.go(-1) : this.$router.push('/')
    }
  }
}
</script>

<style scoped lang="scss">
.warning-icon {
  font-size: 2.438rem;
  border-color: #FB8C00 !important;
}
.text-custom-legend {
  font-size: 1.125rem;
}
.zt-modal-footer {
  background-color: #EEEEEE;
}
::v-deep {
  .zt-modal {
    box-shadow: 0 3px 4px rgba(0, 0, 0, 0.14), 0 3px 3px rgba(0, 0, 0, 0.12),
    0 1px 8px rgba(0, 0, 0, 0.2);
  }
  .zt-modal.rounded {
    border-radius: .375rem!important;
  }
  button.button-cancel {
    color: #707070!important;
    background-color: transparent!important;
  }
}
</style>
